"use strict";

var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var Button_1 = __importDefault(require("@material-ui/core/Button"));

var Grid_1 = __importDefault(require("@material-ui/core/Grid"));

var prop_types_1 = __importDefault(require("prop-types"));

var react_1 = __importDefault(require("react"));

var constants_1 = require("../../../constants");

var utils_1 = require("../../../utils");

var Header_1 = __importDefault(require("../../Card/Header"));

var Base_1 = __importDefault(require("../Base"));

var Badge_1 = __importDefault(require("./Badge"));

require("./style.scss");
/**
 * Employer Moment.
 */


var EmployerMoment = function EmployerMoment(props) {
  var color = props.color,
      data = props.data;
  /* eslint-disable react/jsx-props-no-spreading */

  var renderBadge = function renderBadge(badgeProps) {
    return react_1.default.createElement(Grid_1.default, {
      className: "employer-badge-grid-item",
      item: true
    }, react_1.default.createElement("div", {
      style: {
        width: 350
      }
    }, react_1.default.createElement(Badge_1.default, __assign({}, badgeProps))));
  };

  var renderInfoBox = function renderInfoBox(_a) {
    var description = _a.description,
        label = _a.label,
        textColor = _a.textColor,
        website = _a.website;
    return react_1.default.createElement(Grid_1.default, {
      className: "employer-info-box",
      item: true
    }, react_1.default.createElement(Header_1.default, {
      text: label
    }), react_1.default.createElement("div", null, description), website && react_1.default.createElement(Button_1.default, {
      className: "employer-info-box__button",
      href: website,
      style: {
        color: textColor
      },
      target: "_blank",
      variant: "outlined"
    }, "Learn More"));
  };

  var sections = data.map(function (employer, index) {
    var left = !(0, utils_1.isEven)(index);
    var label = employer.label;
    var key = label + "-" + index;
    var accentColor = left ? color.background : color.text;
    var textColor = left ? color.text : color.background;
    var angleDirection = left ? 'left' : 'right';

    var employerProps = __assign(__assign({}, employer), {
      accentColor: accentColor,
      textColor: textColor
    });

    var angleClasses = (0, utils_1.classList)('angle', "angle-" + angleDirection);
    return react_1.default.createElement("div", {
      className: "story-employer-section",
      key: key
    }, react_1.default.createElement("div", {
      className: angleClasses,
      style: {
        background: accentColor
      }
    }), react_1.default.createElement("div", {
      className: "angled-section__background",
      style: {
        background: accentColor,
        color: textColor
      }
    }, react_1.default.createElement(Grid_1.default, {
      alignItems: "center",
      className: "story-employer-section-grid",
      container: true,
      direction: "row",
      justifyContent: "space-evenly",
      spacing: 2
    }, left ? react_1.default.createElement(react_1.default.Fragment, null, renderInfoBox(employerProps), renderBadge(employerProps)) : react_1.default.createElement(react_1.default.Fragment, null, renderBadge(employerProps), renderInfoBox(employerProps)))));
  });
  return react_1.default.createElement(Base_1.default, __assign({}, props), sections);
};

EmployerMoment.propTypes = {
  /** Determines the background and text color of the `Moment` header. */
  color: prop_types_1.default.shape({
    background: prop_types_1.default.string,
    text: prop_types_1.default.string
  }),

  /** Determines the information to put in the `Badge`s. */
  data: prop_types_1.default.arrayOf(prop_types_1.default.object).isRequired,

  /** Used to serialize the order of the `Moment`s in a `Story` */
  index: prop_types_1.default.number,

  /** Determines the `SideBarSection` text of the `Moment`. */
  label: prop_types_1.default.string,

  /** Paragraph text underneath the title in `Moment` header */
  subtitle: prop_types_1.default.string,

  /** Main heading element of the `Moment` */
  title: prop_types_1.default.node,

  /** The type of `Moment` */
  type: prop_types_1.default.string
};
EmployerMoment.defaultProps = __assign(__assign({}, constants_1.MOMENT_BASE_DEFAULT_PROPS), {
  layout: constants_1.MomentLayout.Employer,
  type: constants_1.MomentType.Employer
});
exports.default = EmployerMoment;